import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-basalt-carbon text-ozone-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-bold text-solar-kinetic mb-4">SUSTAINIFY<sup className="text-sm">®</sup></h3>
            <p className="text-sm text-ozone-white/80 mb-4">
              Consulting for good. Advisory and delivery consulting for people, planet, and infrastructure.
            </p>
            <div className="space-y-2 text-sm">
              <div className="flex items-center space-x-2">
                <Mail size={16} className="text-solar-kinetic" />
                <a href="mailto:info@sustainify.com.au" className="hover:text-solar-kinetic transition-colors">
                  info@sustainify.com.au
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <MapPin size={16} className="text-solar-kinetic" />
                <span>Kabi Kabi Country · The Wharf Mooloolaba, Sunshine Coast</span>
              </div>
              <div className="flex items-center space-x-2 pt-2">
                <a 
                  href="https://www.linkedin.com/company/sustainify-group/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  data-testid="footer-linkedin-link"
                  className="inline-flex items-center space-x-2 text-solar-kinetic hover:text-ozone-white transition-colors"
                >
                  <Linkedin size={20} />
                  <span className="font-medium">Follow us on LinkedIn</span>
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-solar-kinetic">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-solar-kinetic transition-colors">Home</Link></li>
              <li><Link to="/insights" className="hover:text-solar-kinetic transition-colors">Insights</Link></li>
              <li><Link to="/impact" className="hover:text-solar-kinetic transition-colors">Impact</Link></li>
              <li><Link to="/collaborate" className="hover:text-solar-kinetic transition-colors">Collaborate</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold mb-4 text-solar-kinetic">Our Services</h4>
            <ul className="space-y-2 text-sm text-ozone-white/80">
              <li>Project & Program Management</li>
              <li>Organisational Transformation</li>
              <li>Strategy & Governance</li>
            </ul>
          </div>
        </div>

        {/* Indigenous Acknowledgement */}
        <div className="mt-12 pt-8 border-t border-ozone-white/20">
          <p className="text-sm text-center text-ozone-white/80">
            We acknowledge the Kabi Kabi people as the Traditional Custodians and intergenerational stewards of the Sunshine Coast. 
            As an ally business we're committed to working with Indigenous communities and businesses around Australia as genuine partners.
          </p>
        </div>

        {/* Copyright */}
        <div className="mt-8 text-center text-sm text-ozone-white/60">
          <p>© {new Date().getFullYear()} Sustainify. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;